<div class="module-wrapper content-wrapper">
  <mat-card>
    <mat-card-content>
      <div class="row">
        <div class="col-lg-4">
          <img class="img" src="../../../assets/dr-reddeys-1.jpg">
        </div>
        <div class="col-lg-8 home-desc">
          <ul>
            <li style="padding-left:10px">{{'home.point1' | translate}}</li><br><br>
            <li style="padding-left:10px">{{'home.point2' | translate}}</li><br><br>
            <li style="padding-left:10px">{{'home.point3' | translate}}</li><br><br>
            <li style="padding-left:10px">{{'home.point4' | translate}}</li><br><br>
            <li style="padding-left:10px">{{'home.point5' | translate}}</li>
          </ul>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
